import { create } from "zustand";

interface WebsocketState {
  enabled: boolean;
  enableWebsockets: () => void;
  disableWebsockets: () => void;
}

export const useWebsocketStore = create<WebsocketState>((set) => ({
  enabled: true,
  enableWebsockets: () => set({ enabled: true }),
  disableWebsockets: () => set({ enabled: false }),
}));
